import * as React from "react";

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;

const ErrorMessage: React.SFC<Props> = props => {
  return <span {...props} data-error-message />;
};

export default ErrorMessage;

export function findErrorMessageElements() {
  return document.querySelectorAll("[data-error-message]");
}



// WEBPACK FOOTER //
// ./frontend/src/common/components/ErrorMessage.tsx